import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import HomePage from "./HomePage";
import Dashboard from "./Dashboard";
import RequestDetail from "./RequestDetail";
import NewRequestForm from "./NewRequestForm";
import Navigation from "./Navigation";
import ProfileSettings from "./profile";
import ManagerDashboard from "./ManagerDashboard";
import ManagerReview from "./ManagerReview";
import LocalesManagement from "./LocalesManagement";
import JobDetail from "./JobDetail";
import "./App.css";


function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Check for an existing session immediately on load
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // 2. Listen for auth changes (login, logout, token refresh)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Prevent redirecting while we are still checking the session
  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }
  const AdminRoute = ({ children, userProfile }) => {
    if (userProfile?.role !== 'admin') {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  };

  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={session ? <Dashboard /> : <Navigate to="/" />}
        />
        <Route
          path="/request/:requestNumber"
          element={session ? <RequestDetail /> : <Navigate to="/" />}
        />
        <Route
          path="/new"
          element={session ? <NewRequestForm /> : <Navigate to="/" />}
        />
        <Route
          path="/profile"
          element={session ? <ProfileSettings /> : <Navigate to="/" />}
        />
        <Route
          path="/manager"
          element={session ? <ManagerDashboard /> : <Navigate to="/" />}
        />
        <Route
          path="/manager/review/:id"
          element={session ? <ManagerReview /> : <Navigate to="/" />}
        />
        <Route
          path="/request/:requestNumber/job/:jobId"
          element={session ? <JobDetail /> : <Navigate to="/" />}
        />
        <Route
          path="/manager/locales"
          element={session ? <LocalesManagement /> : <Navigate to="/" />}
        />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;